var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlazingWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.46,411a6,6,0,0,0,5.24,1l192.92-53.81a6,6,0,0,0,4.39-5.78V159.61a6,6,0,0,0-4.39-5.77L169.7,100a6,6,0,0,0-7.62,5.77V406.2A6,6,0,0,0,164.46,411Zm9.62-297.26L355,164.17V347.83L174.08,398.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.15,439.6c13.58,1.36,40.77,4.13,54.33,5.49a6.4,6.4,0,0,0,2.22-.19l242.92-67.75a6,6,0,0,0,4.39-5.78V262.2a9.28,9.28,0,0,1,7,6.32l12.45,39.34a6,6,0,1,0,11.44-3.62L410.45,264.9A21.23,21.23,0,0,0,392,250.09V140.63a6,6,0,0,0-4.39-5.78L144.84,67.14a6.44,6.44,0,0,0-2.27-.24L88.15,72.4a6,6,0,0,0-5.39,6V433.63A6,6,0,0,0,88.15,439.6Zm48.93-7.12L121.92,431V81.05l15.16-1.53ZM380,250h-2.88a6,6,0,0,0,0,12H380V366.81L149.08,431.22V80.78L380,145.19ZM94.76,83.8l15.16-1.54V429.74L94.76,428.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.2,169.28a6,6,0,0,0,4.25-1.76l17.89-17.89c5.43-5.77-2.7-13.92-8.49-8.49L189,159C185.16,162.67,188,169.41,193.2,169.28Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M234.62,143.82,189,189.48a6,6,0,1,0,8.48,8.48l45.67-45.66C248.53,146.54,240.42,138.37,234.62,143.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlazingWindow);
export default __webpack_public_path__ + "static/media/glazing-window.65bbd41907b2b81a1958b7ae10858a42.svg";
export { ForwardRef as ReactComponent };